import type { TooltipProps as MantineTooltipProps } from '@mantine/core';
import { Tooltip as MantineTooltip } from '@mantine/core';

import { Flex } from '@/new_src/view/components/Flex';
import { Text } from '@/new_src/view/components/Text';

import styled from 'styled-components';
import { defaultTheme } from '@/theme';

/**
 * @NoneHeadlessComponent
 * @issues Tooltip children이 SVG Component인 경우 정상작동하지 않아 wrapper로 한 번 감싸주어야 함
 * @see https://www.figma.com/design/t8VINTS1iMOuGc9YmmFyxI/%5BJANGBOO%5D-%EC%8A%A4%ED%8C%AC%EB%94%A7-%EB%94%94%EC%9E%90%EC%9D%B8-%EC%8B%9C%EC%8A%A4%ED%85%9C?node-id=364-350&m=dev
 */

const TOOLTIP_MAX_WIDTH = 600;
const TOOLTIP_MAX_WIDTH_IN_MODAL = 300;

type TooltipBGColor = 'black' | 'white';

export interface TooltipProps extends MantineTooltipProps {
  title?: string;
  color?: TooltipBGColor;
  adjustWidthInModal?: boolean;
}

const TitleTooltip = ({ title, label, color }: Pick<TooltipProps, 'title' | 'label' | 'color'>) => {
  return (
    <Flex direction="column">
      <Flex bdb={`0.5px solid ${color === 'black' ? 'white' : '#212121'}`} mb={3} pb={3}>
        <Text fw="500" size="md">
          {title}
        </Text>
      </Flex>
      {label}
    </Flex>
  );
};

const StyledLabel = styled.div`
  font-size: 12px;
  line-height: 160%;
  & > p {
    font-size: 12px;
    line-height: 116%;
  }
`;

export const Tooltip = ({
  color = 'black',
  title,
  label,
  adjustWidthInModal = false,
  children,
  ...rest
}: TooltipProps) => {
  return (
    <MantineTooltip
      label={title ? <TitleTooltip label={label} title={title} color={color} /> : <StyledLabel>{label}</StyledLabel>}
      color={color === 'black' ? defaultTheme.mantineColors.gray[8] : defaultTheme.mantineColors.gray[1]}
      zIndex={1000}
      radius={4}
      offset={4}
      styles={{
        tooltip: {
          maxWidth: `${adjustWidthInModal ? TOOLTIP_MAX_WIDTH_IN_MODAL : TOOLTIP_MAX_WIDTH}px`,
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
          hyphens: 'auto',
          boxShadow: '0px 0px 9px 4px rgba(0, 0, 0, 0.08)',
          color: color === 'black' ? defaultTheme.mantineColors.gray[1] : defaultTheme.mantineColors.gray[8],
          padding: '8px 12px',
          boxSizing: 'border-box',
          fontSize: '12px',
        },
      }}
      {...rest}
    >
      {children}
    </MantineTooltip>
  );
};
